import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/admin/Login.vue'
import ProfileView from '@/views/admin/profile.vue'
import EditProfileView from '@/views/admin/edit-profile.vue'
import ArticleView from '@/views/admin/article.vue'
import AdminChangePassword from '@/views/admin/change-password.vue'
import ForgotPasswordView from '@/views/admin/forgot-password.vue'
import ResetPasswordView from '@/views/admin/reset-password.vue'
import EmailSentView from '@/views/admin/email-sent.vue'
import BannerView from '@/views/admin/banner.vue'
import ServicesView from '@/views/admin/services.vue'
import IndustriesView from '@/views/admin/industries.vue'
import ClientsView from '@/views/admin/clients.vue'
import ContactUsView from '@/views/admin/contactUs.vue'
import ManageJobView from '@/views/admin/jobManage.vue'
import JobCategoryView from '@/views/admin/jobCategory.vue'
import ManageTeamView from '@/views/admin/teamManage.vue'
import ManageBlogView from '@/views/admin/blogManage.vue'
import BlogCategoryView from '@/views/admin/blogCategory.vue'
import JoinOurTeamView from '@/views/admin/joinOurTeam.vue'
import DashboardView from '@/views/admin/dashboard.vue'
import HomePageView from '@/views/user/HomePage.vue'
import ReadMoreArticleView from '@/views/user/readMoreArticle.vue'
import ReadMoreClientView from '@/views/user/readMoreClients.vue'
import PrivacyPolicyView from '@/components/privacyPolicy.vue'
import TermsConditionView from '@/components/terms&condition.vue'
import OurServicesView from '@/views/user/ourServices.vue'
import UserIndustriesView from '@/views/user/userIndustries.vue'
import OurClientsView from '@/views/user/ourClients.vue'
import CareerView from '@/views/user/career.vue'
import ReadMoreAboutJobView from '@/views/user/readMoreAboutJob.vue'
import OurTeamView from '@/views/user/ourTeam.vue'
import AboutUsView from '@/views/user/aboutUs.vue'
import BlogsView from '@/views/user/blogs.vue'
import ReadMoreBlogsView from '@/views/user/readMoreBlogs.vue'

const routes: Array<RouteRecordRaw> = [
{
path: '/authority/login',
name: 'Login',
component: HomeView
},
{
path: '/authority/profile',
name: 'Profile ',
component: ProfileView
},
{
path:'/authority/edit-profile',
name: 'EditProfile',
component: EditProfileView
},
{
path:'/authority/articles',
name: 'Article',
component: ArticleView
},
{
path: '/authority/change-password',
name: 'ChangePassword',
component: AdminChangePassword
},
{
path: '/authority/forgot-password',
name:'ForgotPassword',
component: ForgotPasswordView
},
{
path: '/authority/reset-password',
name:'ResetPassword',
component: ResetPasswordView
},
{
path: '/authority/email-sent',
name:'EmailSent',
component: EmailSentView
},
{
path: '/authority/Banners',
name: 'Banners',
component: BannerView
},
{
path:'/authority/services',
name: 'Services',
component: ServicesView
},
{
path:'/authority/industry',
name: 'Industrie',
component: IndustriesView
},
{
path:'/authority/clients',
name: 'Clients',
component: ClientsView
},
{
path:'/authority/contactUs',
name: 'ContactUs',
component:ContactUsView
},
{
path:'/authority/manage-job',
name:'Manage-Job',
component:ManageJobView
},
{
path:'/authority/job-category',
name:'Job-Category',
component: JobCategoryView,
},
{
path:'/authority/manage-team',
name:'Manage-Team',
component: ManageTeamView
},
{
path:'/authority/manage-blog',
name:'Manage-Blog',
component: ManageBlogView
},
{
path:'/authority/blog-category',
name:'Blog-Category',
component: BlogCategoryView
},
{
path:'/authority/join-team',
name:'Join-Team',
component: JoinOurTeamView
},
{
path:'/authority/dashboard',
name: 'Dashboard',
component: DashboardView
},
{
path: '/',
name: 'home',
component: HomePageView
},
{
path: '/article/:slug',
name: 'readMoreArticle',
component: ReadMoreArticleView
},
{
path: '/client/:slug',
name: 'readMoreClient',
component: ReadMoreClientView
},
{
path: '/privacy-policy',
name: 'privacy policy',
component: PrivacyPolicyView
},
{
path: '/terms-condition',
name: 'terms-condition',
component: TermsConditionView
},
{
path: '/our-services',
name: 'our-services',
component: OurServicesView
},
{
path: '/industries',
name: 'user-industries',
component: UserIndustriesView
},
{
path: '/client',
name: 'client',
component: OurClientsView
},
{
path: '/career',
name: 'career',
component: CareerView
},
{
path: '/career/:slug',
name: 'readMoreAboutJob',
component: ReadMoreAboutJobView
},
{
path: '/our-team',
name: 'our-team',
component: OurTeamView
},
{
path: '/about-us',
name: 'About-Us',
component: AboutUsView
},
{
path: '/blogs',
name: 'blogs',
component: BlogsView
},
{
path: '/blogs/:slug',
name: 'readMoreBlogs',
component: ReadMoreBlogsView
},
{
    path: '/googlef91901584d24718e.html',
    component: () => import('@/components/GoogleVerification.vue')
},
]

const router = createRouter({
history: createWebHistory(process.env.BASE_URL),
routes
})

export default router